// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TihN","question":"styles_question__KDhtb","description":"styles_description__3QRgc"};